import '@/assets/styles/cart-order.css'

import { MdArrowBack, MdArrowForward } from 'react-icons/md'
import ReactPaginate from 'react-paginate'

import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/modules/shared/components/ui/dialog'

import type { TProductImageOrderInterface } from '../types/product-image-order-interface.type'

export function ProductImageOrderInterface({
  productImages,
}: TProductImageOrderInterface) {
  return (
    <Dialog
      open={productImages.state.isOpenModal}
      onOpenChange={productImages.action.onCloseModal}
    >
      <DialogContent className="p-2">
				<DialogHeader>
					<DialogTitle>Imagens do produto</DialogTitle>
				</DialogHeader>
        {productImages.state.currentItems && (
          <>
            {productImages.state.currentItems?.map((item) => (
              <div
                key={item.idFoto}
                className=" flex justify-center items-center"
              >
                <img
                  src={item.imagem}
                  alt="Foto do produto"
                  className="object-contain"
                />
              </div>
            ))}

            {productImages.state.pageCount > 1 && (
              <ReactPaginate
                breakLabel="..."
                nextLabel={<MdArrowForward size={20} />}
                onPageChange={productImages.action.onPageClick}
                pageRangeDisplayed={5}
                pageCount={productImages.state.pageCount}
                previousLabel={<MdArrowBack size={20} />}
                renderOnZeroPageCount={null}
                pageClassName="list-group"
                pageLinkClassName="list-group-item"
                nextLinkClassName="next-button"
                previousLinkClassName="previous-button"
                containerClassName="container-pagination"
              />
            )}
          </>
        )}
      </DialogContent>
    </Dialog>
  )
}
